import { NgModule } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { MatIconModule, MatIconRegistry } from '@angular/material/icon';

const chatIcons = [
  'chat',
  'delete',
  'exit',
  'lightning',
  'maximize',
  'minimize',
  'robot',
  'send',
  'brain',
  'loader',
  'download',
  'check',
  'chevron-down'
];

@NgModule({
  imports: [MatIconModule],
  exports: [MatIconModule],
})
export class ChatIconsModule {
  constructor(
    matIconRegistry: MatIconRegistry,
    domSanitizer: DomSanitizer
  ) {
    const iconPath = 'assets/icons/v3-bps/chat';

    chatIcons.forEach((icon) => {
      matIconRegistry.addSvgIcon(
        `chat-${icon}`,
        domSanitizer.bypassSecurityTrustResourceUrl(`${iconPath}/${icon}.svg`)
      );
    });
  }
}
